import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import ICategory from "@/interfaces/product.category.interfaces";
import categoryService from "@/services/category.service";
import { PaginatedResponse, RequestsBaseReturn } from "@/types/requests.types";

export type UseGetAllCategoriesReturn = RequestsBaseReturn<ICategory[]>;

const useGetAllCategories = (): UseGetAllCategoriesReturn => {
  const {
    data,
    isValidating: isLoading,
    error,
  } = useSWR<PaginatedResponse<ICategory>, Error>(
    SWR_KEYS.getCategories,
    () => categoryService.getAll({ pageNumber: 1, pageSize: 1000 }),
    {
      revalidateOnFocus: false,
      shouldRetryOnError: false,
    }
  );

  return { 
    data: data?.items || [], 
    isLoading, 
    error 
  };
};

export default useGetAllCategories;
